module.exports = __webpack_public_path__ + "assets/sushi_active-764303.svg";